/**
 * engine2相关接口
 */
import { fetchApi } from "../interceptor"

const ENGINE2_CONTEXT = "engine2/data/api-v2"

/**
 * 【首页】 查询应用下的分类和应用详细
 * @param {*} data
 * appId=应用id
 * p=pageId
 * w=websitedId
 * wf=wfwfid
 */
export const queryAppCategoryAndApp = data => {
  const url = `${ENGINE2_CONTEXT}/${data.appId}/rest-classify`
  const param = {
    p: data.pageId,
    w: data.websiteId,
    wfwfid: data.wfwfid
  }
  if(data.filterClassify) {
    param.filterClassify = encodeURIComponent(JSON.stringify(data.filterClassify))
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 更多页面使用，openType=1，且showType>1时调用】查询单个分类详细（带简介，不带数据）
 * @param {*} data
 * t 必须【type的publicId】数据源，跟类的id为空时，可以传0
 * ac 非必须【是否查询访问量】默认false，true会查询访问量 viewNum属性是访问量
 */
export const queryClassifyDetail = data => {
  let url = `${ENGINE2_CONTEXT}/${data.t}/get-classify`
  if (data.ac) url += `?ac=${data.ac}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 【首页使用】分类下数据（由 /rest-classify 构造好，前端只需要替换t,p,p2,sw，params等参数）
 * 【更多页面使用，openType==1&&(showType==1||showType==3)时】直接查询分类下的数据列表，appId写死0，其它参数根据url上对应取值
 * @param {*} data
 * appPublicId必须【值为0，此值仅用作占位】
 * e 必须【engineInstance的publicId】
 * t 非必须【分类的publicId，默认取第一个分类的publicId】
 * p 非必须【页码】 默认1
 * p2 非必须【分页数】 默认0
 * letter 非必须【数据首字母查询】
 * nv 非必须【是否查询访问量，开启后查询接口会比较慢，尽量别用】默认false
 */
export const queryClassifyData = data => {
  const url = `${ENGINE2_CONTEXT}/${data.t}/type/datas`
  return fetchApi(url, data.param, "GET", "params")
}

/**
 * 面包屑列表+分类数据查询地址
 * @param {*} data
 * typeId=分类id
 */
export const queryCrumbData = data => {
  let url = `${ENGINE2_CONTEXT}/crumb/${data.typeId}`
  if (data.e) url += `/${data.e}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 【详情页使用】详情数据（由 {appId}/type/datas构造好，前端只需要替换参数d ）
 * @param {*} data
 * e=engineInstance的publicId
 * t=分类的publicId（数据源没有分类时，已构建好）
 * d=具体详情数据的publicId（数据源也取此字段）
 * nc = {查询访问量 1 查访问量 0 不查访问量}  取  viewNum 字段
 * np = {1 查询发布人 0不查询}  取 publisher 字段
 */
export const queryDetailData = data => {
  const url = `${ENGINE2_CONTEXT}/detail/data/${data.e}/${data.t}/${data.d}`
  const param = {
    nc: data.nc,
    np: data.np,
    topt: data.t,
    pan: true // 获取上一篇下一篇标志
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 图表数据
 * @param {*} data
 * appId=应用id
 * ‍sw=检索关键字
 * params=复杂表达式
 */
export const queryChartData = data => {
  const url = `${ENGINE2_CONTEXT}/chart/${data.appId}/data`
  const param = {
    sw: data.sw,
    params: data.params
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 搜索应用下的所有引擎+搜索引擎关联关系
 * @param {*} data
 * appId=应用id
 */
export const querySearchEngineList = data => {
  const url = `${ENGINE2_CONTEXT}/list-search/${data.appId}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 获取搜索应用下的快捷入口
 * @param {*} data
 * searchId=搜索id
 * publicId
 */
export const querySearchFastLink = data => {
  const url = `engine2/search/searchFastLink/getFastLinkListByGroup?searchId=${data.searchId}&e=${data.publicId}&group=all`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 搜索列表,返回的search的encId属性
 * @param {*} data
 * appId=应用id
 */
export const querySearchList = data => {
  const url = `${ENGINE2_CONTEXT}/list-search/${data.appId}}`
  fetchApi(url, null, "GET", "params")
}

/**
 * 搜索引擎下的分类
 * @param {*} data
 * encId=引擎id
 */
export const querySearchEngineClassify = data => {
  const url = `${ENGINE2_CONTEXT}/list-search-types/${data.typeId}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 站内检索es里的数据
 * @param {*} data
 * encId=引擎id
 */
export const querySearchEngineData = data => {
  const url = `${ENGINE2_CONTEXT}/${data.p}/${data.wfwfid}/search-list`
  return fetchApi(url, data.param, "GET", "params")
}

/**
 * 修改应用属性
 * @param {*} data
 * publicId 必须 【rest-classify接口返回dataUrl里的的e（engineInstanceId）参数】
 * openSensitiveWords 非必须【开启铭感词审核】true开启，false不开，可以为空，为空时修改不生效
 * p 非必须【首页分页查询数量】主要用于控制all-request，可以为空，为空时修改不生效
 * checkIp 非必须【ip或登录等访问权限】1开启，0不开，可以为空，为空时修改不生效
 * appName  非必须【应用名称】可以为空，为空时修改不生效
 */
export const updateAppAttr = data => {
  const url = `${ENGINE2_CONTEXT}/setting/advanced`
  return fetchApi(url, data.param, "GET", "params")
}
/**
 * 兑换详情地址的构建参数
 * engineInstanceId 必须【数字engineInstanceId】
 * sign 必须【engineInstanceId构建的sign，由/engine2/data/api-v2/{p}/{wfwfid}/search-list返回】
 * dataId 必须【数字数据id】
 */
export const queryExchangeDetail = data => {
  // const url = `${ENGINE2_CONTEXT}/search-detail/${data.engineInstanceId}/${data.sign}/${data.dataId}/`
  const url = `${ENGINE2_CONTEXT}/getSearchListPubIds/${data.engineInstanceId}/${data.sign}/${data.dataId}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 获取应用管理后台
 * type 必须【engineInstance的type，前端根据组件类型，判断传入，CHART_SCREEN,CHART, GENERAL,SEARCH，仅这4中可用】
 * a 必须【engineInstance的appPublicId】
 */
export const queryAppManage = data => {
  const url = `${ENGINE2_CONTEXT}/admin/${data.type}/${data.a}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 添加搜索记录
 * appId 必须【engineInstance的appPublicId】
 * searchId 必须【由/engine2/data/api-v2/{p}/{wfwfid}/search-list返回的datas数组里，任意搜索的id】
 * p 必须【page的publicId】
 * sw  非必须【检索词】
 * searchUrl 非必须【搜索地址】
 */
export const addSearchRecord = data => {
  const url = `${ENGINE2_CONTEXT}/search-record`
  return fetchApi(url, data, "POST", "body")
}

/**
 * 修改应用分页属性
 * a            必须 【rest-classify接口返回dataUrl里的engineInstance的appPublicId参数】
 * publicId 必须 【rest-classify接口返回dataUrl里的engineInstance的publicId参数】
 * p2          非必须【修改的应用分页数】默认10
 */
export const updateAppPageAttr = data => {
  let url = `${ENGINE2_CONTEXT}/admin/${data.a}/update-p?e=${data.publicId}`
  if (data.p2) url += `&p2=${data.p2}`
  if (data.isApp) url += `&a=${data.isApp}`
  return fetchApi(url, null, "POST", "body")
}

/**
 * 批量修改应用分页属性
 * appId            必须 【rest-classify接口返回dataUrl里的engineInstance的appPublicId参数】
 * e 必须 【rest-classify接口返回dataUrl里的engineInstance的publicId参数】
 * p2          非必须【修改的应用分页数】默认10
 * a 非必需【是否是移动端】
 * 
 */
export const updateAppPageAttrBatch = data => {
  let url = `${ENGINE2_CONTEXT}/admin/update-p-batch`
  return fetchApi(url, data, "POST", "body")
}

/**
 * 获取网站下的聚合搜索引擎列表
 */
export const queryGroupSearchEngineList = () => {
  const url = `${ENGINE2_CONTEXT}/group-search/list-engine`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 根据engineInstanceId获取聚合搜索引擎下的数据
 */
export const queryGroupSearchEngineData = data => {
  const url = `rw/api-v2/${data.p}/${data.wfwfid}/search-list`
  return fetchApi(url, data.param, "GET", "params")
}

/**
 * 修改数据推送接口
 * @param
 * {
    "interfacePushRule": {
        "addAndUpdateRule": "1,2",   //1表示新增时，2表示修改时
        "engineInstanceId": 5969653,   //对应应用的engineInstanceId
        "id": 1038,   //有则修改，为空为新增
        "method": 1,   //0表示全部数据，1表示置顶数据
        "pushType": "1",   //推送置接口固定为1
        "status": true,   //true开启推送，false关闭
        "url": "http://192.168.1.220:8301/app/push/data/form?fid=29153&formId=1360135&schoolCode=3632000063&status=已上传，未修改"
    }
}
 * @returns
 */
export const editDataPushRule = data => {
  const url = "engine2/admin/general/update/push-rule"
  return fetchApi(url, data, "post", "body")
}

/**
 * 查询数据推送规则
 * @param engineInstanceId
 *
 }
 * @returns
 */
export const getDataPushRule = data => {
  const url = `engine2/push-rule/${data.engineInstanceId}/get`
  return fetchApi(url, null , "get", "params")
}

/**
 * 获取数据中心地址
 * @param {*} data 
 * @returns 
 */
export const getDataCenterUrl = data => {
  const { type, appId, ...params } = data
  const url = `engine2/data-management-api/${type}/${appId}`
  return fetchApi(url, params , "get", "params")
}

/**
 * 获取数据配置信息
 * @param {*} data 
 * @returns 
 */
export const getContentConfig = data => {
  const { engineType, appId } = data
  const url = `engine2/data/center/content/${engineType}/${appId}/get-content-config`
  return fetchApi(url, null, "post", "body")
}

/**
 * 设置数据为本地数据
 * @param {*} data 
 * @returns 
 */
export const setLocalData = (data) => {
  const { appId, type } =  data
  const url = `engine2/admin/${type}/${appId}/source/local`
  return fetchApi(url, null, "post", "body")
}

/**
 * 获取数据EngineInstance信息
 * @param {*} data
 * @returns
 */
export const getEngineInstance = data => {
  const { pageId, websiteId, appId } = data
  const params = {
    p: pageId,
    w: websiteId
  }
  const url = `engine2/data/api-v2/${appId}/engine-instance`
  return fetchApi(url, params , "get", "params")
}

/* 
* 大屏是否必须在iframe中访问
*/
export const getMustInIframe = data => {
  const url = `v2/w-i-c`
  return fetchApi(url, "" , "get", "params")
}